import { RootState } from '@cp/src/store';
import { getNameInitials } from '@cp/src/utils/commonUtils';
import { Avatar, Timeline, Typography } from '@navi/web-ui/lib/primitives';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IActivityLog, TicketStatus } from '../../types';
import TicketTimeline from './TicketTimeline';
import cx from 'classnames';
import SuspenseLoader from '@cp/src/components/SkeletonLoader/SuspenseLoader';
import CommentLoader from './CommentLoader';
import CommentWidget from './CommentWidget';

const ActivityLog = (props: IActivityLog) => {
  const { ticket, loading } = props;
  const isEditingAllowed = [TicketStatus.TODO, TicketStatus.IN_PROGRESS].includes(ticket?.status);
  const activityLogs = ticket?.activityLogs || [];

  const user = useSelector((state: RootState) => state?.common?.userData);

  const commentWidget = isEditingAllowed
    ? [
        {
          pointer: (
            <Avatar sizeVariant="sm" color="var(--green-light-2)">
              <Typography variant="h6" color="var(--text-primary)">
                {getNameInitials(user?.name ?? '')}
              </Typography>
            </Avatar>
          ),
          stageComponent: <CommentWidget ticket={ticket} />
        }
      ]
    : [];

  const timelineData = useMemo(() => {
    if (!loading)
      return activityLogs?.map(activity => {
        const isLoggedInUser = user.referenceId === activity?.activityBy?.referenceId;
        return {
          pointer: (
            <Avatar
              color={isLoggedInUser ? 'var(--green-light-2)' : 'var(--purple-base)'}
              sizeVariant="sm"
            >
              <Typography variant="h5" color="var(--text-primary)">
                {getNameInitials(activity?.activityBy?.name)}
              </Typography>
            </Avatar>
          ),
          stageComponent: <TicketTimeline activity={activity} />
        };
      });
    return [];
  }, [activityLogs, loading]);

  const timeline = [...commentWidget, ...timelineData];

  return (
    <SuspenseLoader loading={loading} fallBack={<CommentLoader />}>
      {timeline?.length ? (
        <Typography
          variant="h4"
          color="var(--navi-color-gray-c1)"
          className="font-medium mb-2 px-4"
        >
          Activity log
        </Typography>
      ) : null}
      <div className={cx('px-4 pt-2 overflow-y-auto')}>
        <Timeline data={timeline} />
      </div>
    </SuspenseLoader>
  );
};

export default ActivityLog;
